LS.util.route({
	'account': {
		'$guard:eval': {
			'listings': {
				'$index': {
					':load': 'account.listings',
					':unload': 'account.listings:unload'
				},
				'$num': {
					'$index': {
						':load': 'account.listing',
						':unload': 'account.listing:unload'
					},
					'preview': {
						':load': 'account.listing.preview',
						':unload': 'account.listing.preview:unload'
					},
					'edit:preload:once': () => {
						LS.util.load('account-post');
					}
				},
				'create:preload:once': () => {
					LS.util.load('account-post');
				}
			}
		}
	}
});